/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { MatrixDependencies } from './dependenciesMatrixClass.generated.js';
import { createDenseMatrixClass } from '../../factoriesAny.js';
export var DenseMatrixDependencies = {
  MatrixDependencies,
  createDenseMatrixClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesDenseMatrixClass.generated.js
// module id = L8Pj
// module chunks = 3